// Formatos y colores de las plantillas Excel de importación (mismos que la plantilla de Listas de Precios, PR #93)
export const ExcelFormats = {
    Accounting: '_("$"* #,##0.00_);_("$"* (#,##0.00);_("$"* "-"??_);_(@_)',
    Percentage: '0.00%'
}

const BorderThin = { style: 'thin', color: { rgb: '000000' } }

export const ExcelStyles = {
    metadataTitle: {
        fill: { fgColor: { rgb: '7A8580' } },
        font: { bold: true, color: { rgb: 'FFFFFF' } },
        alignment: { horizontal: 'left' },
        border: { right: BorderThin }
    },
    metadataValue: {
        fill: { fgColor: { rgb: 'F2F2F2' } },
        font: { color: { rgb: '333333' } },
        alignment: { horizontal: 'left' }
    },
    hint: {
        font: { italic: true, color: { rgb: '7F7F7F' } }
    },
    header: {
        font: { bold: true, color: { rgb: 'FFFFFF' } },
        fill: { fgColor: { rgb: '89A39E' } },
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true }
    },
    greyRow: {
        fill: { fgColor: { rgb: 'F2F2F2' } },
        font: { color: { rgb: '7F7F7F' } },
        alignment: { horizontal: 'left' }
    },
    editable: {
        fill: { fgColor: { rgb: 'FFFFFF' } },
        font: { color: { rgb: '000000' } },
        border: {
            top: BorderThin,
            bottom: BorderThin,
            left: BorderThin,
            right: BorderThin
        }
    }
}
